import { createSelector } from "reselect";
import get from "lodash/get";

export const getErrorMessage = createSelector(
  [(state, slice) => get(state, `${slice}.error`, undefined)],
  err => err,
);
